module.exports = __webpack_public_path__ + "img/icon_e33.28f16b83.png";